import { OUTLET_TYPES } from './bookingConfig';
import { resolveBookingDateTime } from './resolveBookingDateTime';

export const isWeekdayAtOrBefore6pm = (selectedDate, selectedTime) => {
  if (!selectedDate || !selectedTime) return false;
  const appointment = resolveBookingDateTime(selectedDate, selectedTime);
  if (!appointment.date || !appointment.time) return false;

  const [dd, mm, yyyy] = appointment.date.split('-').map(Number);
  const bookingDate = new Date(yyyy, mm - 1, dd);
  const dayOfWeek = bookingDate.getDay();
  if (dayOfWeek === 0 || dayOfWeek === 6) return false;

  const time = appointment.time.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?$/i);
  if (!time) return false;
  let hours = Number(time[1]);
  const minutes = Number(time[2]);
  const seconds = Number(time[3] || 0);
  if (minutes > 59 || seconds > 59) return false;
  if (time[4]) {
    if (hours < 1 || hours > 12) return false;
    hours = hours % 12 + (time[4].toUpperCase() === 'PM' ? 12 : 0);
  } else if (hours > 23) return false;

  return dayOfWeek >= 1 && dayOfWeek <= 5 && hours * 3600 + minutes * 60 + seconds <= 18 * 3600;
};

/**
 * Determines isMembershipApplied and isMemberRateApplied per the backend spec:
 *
 * | isMembershipApplied | isMemberRateApplied | Result       |
 * |---------------------|---------------------|--------------|
 * | false               | false               | No MemberRate |
 * | true                | false               | MemberRate   |
 * | true                | true                | MemberRateOP |
 *
 * Standard/Classic and Plus members qualify for MemberRateOP Monday–Friday at or
 * before 18:00, excluding public holidays. Premium members never use MemberRateOP.
 * This helper determines flags, not prices.
 */
export const computeMemberFlags = (membership, outletTypeID, selectedDate, selectedTime, outletTypeName, isPublicHoliday = false) => {
  const isMembershipApplied = membership === true || membership === 1 || membership === '1';

  if (!isMembershipApplied) {
    return { isMembershipApplied: false, isMemberRateApplied: false };
  }

  const typeName = typeof outletTypeName === 'string' ? outletTypeName.trim().toLowerCase() : '';
  // Plus outlets use the same member-rate rules as Classic.
  const isMemberRateOutlet = typeName
    ? typeName === 'classic' || typeName === 'standard' || typeName === 'plus'
    : Number(outletTypeID) === OUTLET_TYPES.CLASSIC || Number(outletTypeID) === OUTLET_TYPES.PLUS;
  if (!isMemberRateOutlet) {
    // Premium outlet: membership applies but rate discount does not
    return { isMembershipApplied: true, isMemberRateApplied: false };
  }

  const isHoliday = isPublicHoliday === true || isPublicHoliday === 1 || isPublicHoliday === '1';
  const isMemberRateApplied = !isHoliday && isWeekdayAtOrBefore6pm(selectedDate, selectedTime);
  return { isMembershipApplied: true, isMemberRateApplied };
};

